import React from 'react';
import ReactDOM from 'react-dom';
// import App from "./components/App";
import "./styles.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Header,
  BackToTop,
  Footer,
  Hello,
  Lab,
  Contact
} from "./components";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Header />
      <BackToTop />
      <Routes>
        <Route path="/" element={<Hello />} />
        <Route path="/lab" element={<Lab />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);


const hamburger = document.querySelector(".hamburger");
const navMenu = document.querySelector(".navlist");
const navLink = document.querySelectorAll(".navlink");

hamburger.addEventListener("click", mobileMenu);

function mobileMenu() {
    hamburger.classList.toggle("active");
    navMenu.classList.toggle("active");
}

navLink.forEach(n => n.addEventListener("click", closeMenu));

function closeMenu() {
    hamburger.classList.remove("active");
    navMenu.classList.remove("active");
}

serviceWorker.unregister();
